import React from 'react';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import styles from './styles/tech-introduction-card.module.css';

import {ReactComponent as ArrowImg} from '../../assets/main08/arrow.svg';
import {ReactComponent as ComputerLanguageImg} from '../../assets/main08/computer-language.svg';
import {ReactComponent as ComputerSmallImg} from '../../assets/main08/computer-small.svg';
import {ReactComponent as OriginalLanguageImg} from '../../assets/main08/original-language.svg';
import {ReactComponent as OriginalSmallImg} from '../../assets/main08/original-small.svg';

export default function TechIntroductionCard() {
    const mobileSmall = useMediaQuery('(max-width: 480px)');
    const mobileMedium = useMediaQuery('(min-width: 481px) and (max-width: 768px)');

return (
    <div className={styles.wrapper}>
        <p>Text-to-<span>SQL</span> 기술이란?</p>  
        <p>자연어(사람들의 언어)를 SQL(컴퓨터 언어)로 변환하는 기술</p>
        <div className={styles.container}>
            <div className={styles.boxItem}>
                {mobileSmall || mobileMedium ? <OriginalSmallImg /> : <OriginalLanguageImg />}
                <div>
                    <p className={styles.title}>자연어(Text)</p>
                    {!mobileMedium && <p className={styles.content}>가장 많은 원자재 소비가<br/>발생한 제품은 어떤 제품인가요?</p>}
                    {mobileMedium && <p className={styles.content}>가장 많은 원자재 소비가 발생한 제품은 어떤 제품인가요?</p>}
                </div>
            </div>
            <div className={styles.arrow}>
                <ArrowImg />
            </div>
            <div className={styles.boxItem}>
            {mobileSmall || mobileMedium ? <ComputerSmallImg /> : <ComputerLanguageImg />}
                <div>
                    <p className={styles.title02}>컴퓨터 언어(SQL)</p>
                    <p className={styles.content02}>
                        {mobileSmall
                            ? <>
                                SELECT 제품ID, SUM(원자재량)<br/>
                                AS 총원자재사용량<br/>
                                FROM 생산세부정보<br/>
                                GROUP BY 제품ID<br/>
                                ORDER BY 총원자재사용량 DESC<br/>
                                LIMIT 1;
                            </>
                            : <>
                                SELECT 제품ID, SUM(원자재량) AS 총원자재사용량<br/>
                                FROM 생산세부정보<br/>
                                GROUP BY 제품ID<br/>
                                ORDER BY 총원자재사용량 DESC<br/>
                                LIMIT 1;   
                            </>
                        }
                    </p>
                </div>
            </div>
        </div>
    </div>
  );
}
